<template>
	<div class="block_spacer"></div>
</template>

<script>
	export default{
		name:'block_spacer'
	}
</script>
